/**
 * @generated SignedSource<<c8b7d2d3d61d6bc17e167937e48000e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type advertisersQueueItemConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId?: string;
      readonly " $fragmentSpreads": FragmentRefs<"homeAdvertiserContentItemContent">;
    };
  }>;
  readonly " $fragmentType": "advertisersQueueItemConnection";
};
export type advertisersQueueItemConnection$key = {
  readonly " $data"?: advertisersQueueItemConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"advertisersQueueItemConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "advertisersQueueItemConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "homeAdvertiserContentItemContent"
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemConnection",
  "abstractKey": null
};

(node as any).hash = "89344668b9357a81e2d342c86ea43df6";

export default node;
